'use client';

import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';

const ErrorFetchPage = props => {
  const { tags } = props;

  const isInitRef = useRef(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isInitRef.current) {
      isInitRef.current = false;

      if (globalThis.fetch && Array.isArray(tags)) {
        globalThis.fetch('/api/refresh-cache', {
          method: 'POST',
          body: JSON.stringify({ tags }),
        });
      }
    }
  }, [tags]);

  return (
    <div className='mx-auto max-w-[1100px] px-[15px] py-20 lg_px-0'>
      <p className='mb-[20px] font-teko-medium text-[30px] uppercase leading-[28px] text-primary lg_text-[40px] lg_leading-[48px]'>
        Oops! Something went wrong! Please refresh the page and try again.
      </p>

      <button
        type='button'
        disabled={loading}
        onClick={async () => {
          if (globalThis.fetch && Array.isArray(tags)) {
            setLoading(true);
            await globalThis
              .fetch('/api/refresh-cache', {
                method: 'POST',
                body: JSON.stringify({ tags }),
              })
              .catch(() => {});
            setLoading(false);
          }
          window.location.reload();
        }}
        className='font-poppins mt-10 flex h-10 w-full items-center justify-center rounded-[102px] bg-primary text-center text-sm font-bold  text-white  lg_max-w-[260px]'
      >
        REFRESH THIS PAGE{loading && '...'}
      </button>

      <div className='mb-[40px] mt-[40px] lg_mb-[60px]'>
        <p className='mb-[20px] font-teko-medium text-[30px] uppercase leading-[28px] text-primary lg_text-[40px] lg_leading-[48px]'>
          Let&apos;s get you back on track...
        </p>
        <div className='flex flex-col gap-[20px] lg_flex-row lg_gap-[25px]'>
          <Link
            className='flex h-10  w-full items-center justify-center rounded-[102px] border-1 border-solid  border-black text-center text-primary lg_w-[200px] lg_hover_bg-black lg_hover_text-white'
            href={'/mens-boots'}
          >
            Shop Men&apos;s Boots
          </Link>
          <Link
            className='flex h-10  w-full items-center justify-center rounded-[102px] border-1 border-solid  border-black text-center text-primary lg_w-[200px] lg_hover_bg-black lg_hover_text-white'
            href={'/womens-boots'}
          >
            Shop Women&apos;s Boots
          </Link>
          <Link
            className='flex h-10  w-full items-center justify-center rounded-[102px] border-1 border-solid  border-black text-center text-primary lg_w-[200px] lg_hover_bg-black lg_hover_text-white'
            href={'/kids-boots'}
          >
            Shop Kid&apos;s Boots
          </Link>
          <Link
            className='flex h-10  w-full items-center justify-center rounded-[102px] border-1 border-solid  border-black text-center text-primary lg_w-[200px] lg_hover_bg-black lg_hover_text-white'
            href={'/waders'}
          >
            Shop Waders
          </Link>
          <Link
            className='flex h-10  w-full items-center justify-center rounded-[102px] border-1 border-solid  border-black text-center text-primary lg_w-[200px] lg_hover_bg-black lg_hover_text-white'
            href={'/apparel'}
          >
            Shop Apparel
          </Link>
        </div>
      </div>

      <div className=''>
        <p className='mb-[20px] font-teko-medium text-[30px] uppercase leading-[28px] text-primary lg_text-[40px] lg_leading-[48px]'>
          Still have questions?
        </p>
        <span className='font-roboto-regular text-[16px] font-normal lg_text-[18px]'>
          Feel free to contact us at{' '}
          <a
            href='mailto:<cs@hisea.com>'
            className='font-roboto-medium text-[16px] font-medium underline hover_text-primary lg_text-[18px]'
          >
            cs@hisea.com
          </a>
          . We will reply within 48 hours.
        </span>
      </div>
    </div>
  );
};

export default ErrorFetchPage;
